/* istanbul ignore file */
import { useEffect } from 'react';
import type { GenericTrackingEvent } from '@packages/tracking';
import { useTracking } from '@packages/tracking';

type GtmEvent = {
  sourceCategoryId?: string | number;
  rdeTypeAbbr: string;
  outputElementNo: number;
};

type TrackingProps = {
  rdeTypeAbbr?: string;
  elementIndex?: number;
  trackingCondition: boolean;
  sourceCategoryId: string | number;
};

export const useCategoriesRecoTracking = ({
  rdeTypeAbbr,
  elementIndex,
  sourceCategoryId,
  trackingCondition,
}: TrackingProps) => {
  const dispatchGTMEvent = useTracking();

  useEffect(() => {
    if (trackingCondition && rdeTypeAbbr) {
      dispatchGTMEvent<GenericTrackingEvent<GtmEvent>>({
        event: 'ga_event',
        eventAction: 'view',
        eventCategory: 'elementImpression',
        eventLabel: 'categoryRecoImpression',
        eventValue: {
          rdeTypeAbbr,
          outputElementNo: (elementIndex ?? 0) + 1,
          sourceCategoryId,
        },
      });
    }
  }, [dispatchGTMEvent, elementIndex, rdeTypeAbbr, sourceCategoryId, trackingCondition]);
};
